import React from 'react';
import { Button } from 'antd';
import FormInput from '../components/FormInput';
import FormSelect from '../components/FormSelect';
import FormSwitch from '../components/FormSwitch';

const Start = ( { municipalities, onSetShowResults, onSetSalary, onSetMunicipality, onSetAge, valid } ) => {
	return <article>
		<div className="form_container">
			<FormSelect
				values={ municipalities }
				setValue={ onSetMunicipality }
				header="Kerro kotikuntasi"
				defaultValue={ municipalities[ 0 ].name }
				placeholder="Esimerkiksi Tampere"
				width="200px"
			/>
			
			<FormInput
				header="Kerro kuukausipalkkasi"
				setValue={ onSetSalary }
				defaultValue={ 0 }
				width="200px"
			/>
			
			<FormSwitch
				header="Oletko 53–62-vuotias"
				setValue={ onSetAge }
			/>
			
			<div className="button-container">
				<Button
					type="primary"
					size="large"
					shape="round"
					onClick={ () => onSetShowResults( true ) }
					disabled={ !valid }
				>
					Näytä tulos
				</Button>
			</div>
		</div>
	</article>;
};

export default Start;
